export default "__VITE_ASSET__DgcL_2Uc__"